import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';

const AiSiteDesignerIconWrapper = styled.span`
    display: inline-flex;
`;

export const AI_SITE_DESIGNER_LABEL = 'AI Site Designer';

export default function AiSiteDesignerIcon({ label }) {
    return (
        <AiSiteDesignerIconWrapper>
            <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                focusable="false"
            >
                <path
                    d="M8.99996 5.6665C10.3333 4.33317 9.99996 2.6665 10.6666 2.6665C11.3333 2.6665 11 4.33317 12.3333 5.6665C13.6666 6.99984 15.3333 6.6665 15.3333 7.33317C15.3333 7.99984 13.6666 7.6665 12.3333 8.99984C11 10.3332 11.3333 11.9998 10.6666 11.9998C9.99996 11.9998 10.3333 10.3332 8.99996 8.99984C7.66663 7.6665 5.99996 7.99984 5.99996 7.33317C5.99996 6.6665 7.66663 6.99984 8.99996 5.6665Z"
                    fill="#242424"
                />
                <path
                    d="M5.09996 2.23317C5.62145 2.75466 6.66663 2.6665 6.66663 2.99984C6.66663 3.33317 5.638 3.22847 5.09996 3.7665C4.56192 4.30454 4.66663 5.33317 4.33329 5.33317C3.99996 5.33317 4.10827 4.30815 3.56663 3.7665C3.02498 3.22486 1.99996 3.33317 1.99996 2.99984C1.99996 2.6665 3.00821 2.79159 3.56663 2.23317C4.12504 1.67475 3.99996 0.666504 4.33329 0.666504C4.66663 0.666504 4.57847 1.71168 5.09996 2.23317Z"
                    fill="#242424"
                />
                <path
                    d="M4.66663 11.3332C5.33329 11.9998 6.66663 11.8588 6.66663 12.3332C6.66663 12.8075 5.33329 12.6665 4.66663 13.3332C3.99996 13.9998 4.15761 15.3332 3.66663 15.3332C3.17564 15.3332 3.33329 13.9998 2.66663 13.3332C1.99996 12.6665 0.666626 12.847 0.666626 12.3332C0.666626 11.8194 1.99996 11.9998 2.66663 11.3332C3.33329 10.6665 3.16775 9.33317 3.66663 9.33317C4.16551 9.33317 3.99996 10.6665 4.66663 11.3332Z"
                    fill="#242424"
                />
            </svg>
            <VisuallyHidden>{label}</VisuallyHidden>
        </AiSiteDesignerIconWrapper>
    );
}

AiSiteDesignerIcon.propTypes = {
    label: PropTypes.string,
};

AiSiteDesignerIcon.defaultProps = {
    label: AI_SITE_DESIGNER_LABEL,
};
